import $ from 'jquery';
import DataTable from 'datatables.net';
import "./libs/dataTables.bootstrap4.js"
import "./libs/dataTables.rowGroup.js"
import "./libs/rowGroup.bootstrap4.min.js"

function Table($wrapper) {

    /**
     * @type {Table}
     */
    var that = this;

    /**
     * table dom object
     * @type {jQuery}
     */
    var $table;

    /**
     * the dataTable object itself
     * @type {DataTable}
     */
    var dataTableApi;

    var activeFilters = {};

    /**
     * Initialize the aciveFilters Object.
     * It's possible, by e.g. browser navigation (back/forward navigation), that filters are already set (saved in local storage)
     * The dataTables-library applies them automatically
     */
    this.initFilters = function() {
        var search = dataTableApi.columns().search();
        for(var columnIndex = 0; columnIndex < search.length; columnIndex++ ){
            var columnFilters = search[columnIndex].trim().split(' ');

            for(var filterIndex = 0; filterIndex < columnFilters.length; filterIndex++){
                var filter = columnFilters[filterIndex];
                var filterName = filter.split('-')[0];
                if(!activeFilters.hasOwnProperty(columnIndex)) {
                    activeFilters[columnIndex] = {};
                }
                activeFilters[columnIndex][filterName] = filter;
            }
        }
    };

    /**
     * Apply filter
     * @param columnIndex
     * @param filterName
     * @param value
     */
    this.applyFilter = function(columnIndex, filterName, value) {
        // clear filter for column
        if(!value) {
            delete activeFilters[columnIndex][filterName];
            dataTableApi.column(columnIndex).search('', false, true, false ).unique().sort().draw();
            return true;
        }
        if(!activeFilters.hasOwnProperty(columnIndex)) {
            activeFilters[columnIndex] = {};
        }
        activeFilters[columnIndex][filterName] = value;

        var filterString = '';
        for (var filterNameActive in activeFilters[columnIndex]) {
            if (activeFilters[columnIndex].hasOwnProperty(filterNameActive)) {
                filterString = filterString + ' ' + activeFilters[columnIndex][filterNameActive];
            }
        }
        dataTableApi.column(columnIndex).search(filterString, false, true, false ).unique().sort().draw();
    };

    /**
     * Render all filters, gets called after initialization once
     */
    this.renderFilters = function() {
        // iterate each filter type
        $wrapper.find('.js-filter-button').each(function(idx, filterElement) {
            that.renderToggleButtonFilter($(filterElement));
        });
        $wrapper.find('.js-filter-dropdown').each(function(idx, dropdownWrapper) {
            that.renderDropDownFilter($(dropdownWrapper));
        });
        $wrapper.find('.js-filter-clear').click(function() {
            for (var columnIndex in activeFilters) {
                dataTableApi.column(columnIndex).search('', false, true, false ).unique().sort().draw();
            }
            activeFilters = {};

            $wrapper.find('.js-filter-button').removeClass('active').attr('aria-pressed', 'false');
            $wrapper.find('.js-filter-dropdown .js-dropdown-toggle-button')
                .removeClass('active')
                .find('.js-filter-value').text('');
            $wrapper.find('.js-filter-dropdown .active').removeClass('active');

            dataTableApi.search('').draw();
        });
    };

    /**
     * Renders a dropDown filter with multiple options
     * @param {jQuery} $wrapper The wrapper around the dropdown button and menu
     */
    this.renderDropDownFilter = function($wrapper) {
        var filterName =  $wrapper.data('filter-name');
        var $dropdownButton = $wrapper.find(".js-dropdown-toggle-button");
        var $currentFilterLabelContainer = $dropdownButton.find('.js-filter-value');
        var labelUnfiltered = $dropdownButton.text();
        $wrapper.find('[data-toggle-filter]').each(function(idx, filterElement) {
            var $filterElement = $(filterElement);
            var columnIndex = $filterElement.data('column-index');

            if($filterElement.hasClass('active')) {
                that.applyFilter(columnIndex, filterName, $filterElement.data('toggle-filter'));
                $currentFilterLabelContainer.text($filterElement.text());
                $dropdownButton.addClass('active');
            }

            // if a filter (-> search) is already active (e.g. by previous site navigation)
            var currentFilter = $filterElement.data('toggle-filter').trim();
            if(activeFilters[columnIndex][filterName] === currentFilter){
                $currentFilterLabelContainer.text($filterElement.text());
                $filterElement.siblings().removeClass('active');
                $filterElement.addClass('active');
                $dropdownButton.addClass('active');
            }

            $filterElement.click(function () {
                if($filterElement.hasClass('active')) {
                    $currentFilterLabelContainer.text('');
                    $filterElement.removeClass('active');
                    $dropdownButton.removeClass('active');
                    that.applyFilter(columnIndex, filterName, false);
                } else {
                    $currentFilterLabelContainer.text($filterElement.text());
                    $dropdownButton.addClass('active');
                    $filterElement.siblings().removeClass('active');
                    $filterElement.addClass('active');
                    that.applyFilter(columnIndex, filterName, $filterElement.data('toggle-filter'));
                }
            });
        });
    };

    /**
     * Renders a toggle button filter
     * @param {jQuery} $button The toggle button itself
     */
    this.renderToggleButtonFilter = function($button) {
        var filterName =  $button.data('filter-name');
        var columnIndex = $button.data('column-index');
        // rendering for default toggle button filters
        $button.click(function () {
            if($button.hasClass('active')) {
                that.applyFilter(columnIndex, filterName, false);
            } else {
                that.applyFilter(columnIndex, filterName, $button.data('toggle-filter'));
            }
        });

        if($button.hasClass('active')) {
            that.applyFilter(columnIndex, filterName, $button.data('toggle-filter'));
        }

        // if a filter (-> search) is already active (e.g. by previous site navigation)
        var buttonFilter = $button.data('toggle-filter').trim();
        var activeColumnFilters = dataTableApi.column(columnIndex).search().trim().split(' ');
        if(activeColumnFilters.includes(buttonFilter)){
            $button.addClass('active');
        }
    };

    /**
     * Render search
     */
    this.renderSearch = function() {
        // set inital search default value
        if($wrapper.data('search-default')) {
            dataTableApi.search($wrapper.data('search-default')).draw();
        }
        $wrapper.find('.js-fastsearch-button').click(function (event) {
            dataTableApi.search($(event.delegateTarget).data('search-value')).draw();
        });
    };

    /**
     * initialize table
     * @param contentString
     */
    this.init = function(contentString) {
        $wrapper.find('.js-bikealpin-tourtable').DataTable({
            "paging": false,
            "lengthChange": false,
            "responsive": true,
            "stateSave": true,
            "createdRow": function ( row, data, index ) {
                $(row).find("[data-href]").click(function(){
                    document.location.href = $(this).data('href');
                });
            },
            "columnDefs": [
            ],
            // replacing labels
            language: {
                "url": "/_Resources/Static/Packages/Bikealpin.Tour/Translations/dataTables-" + document.documentElement.lang + ".json"
            },
            initComplete: function() {
                dataTableApi = this.api();
                that.initFilters();
                that.renderFilters();
                that.renderSearch();
            },
            drawCallback: function() {
                var pagination = $wrapper.find('.dataTables_paginate');
                if(this.api().page.info().pages > 1) {
                    pagination.show();
                }else{
                    pagination.hide();
                }
            }
        });
    };
    this.init();
}
$(document).ready(function () {
    $('.js-tour-list-table-container').each(function(idx, ele) {
        var table = new Table($(ele));
    });
});
